export default __webpack_public_path__ + "static/media/censorship.3c3d0fe6.png";